import * as React from 'react';
import { useColorScheme } from '@mui/joy/styles';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import IconButton from '@mui/joy/IconButton';
import Stack from '@mui/joy/Stack';
import Avatar from '@mui/joy/Avatar';
import Input from '@mui/joy/Input';
import Button from '@mui/joy/Button';
import Tooltip from '@mui/joy/Tooltip';
import Dropdown from '@mui/joy/Dropdown';
import Menu from '@mui/joy/Menu';
import MenuButton from '@mui/joy/MenuButton';
import MenuItem from '@mui/joy/MenuItem';
import ListDivider from '@mui/joy/ListDivider';
import Drawer from '@mui/joy/Drawer';
import ModalClose from '@mui/joy/ModalClose';
import DialogTitle from '@mui/joy/DialogTitle';

import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import BookRoundedIcon from '@mui/icons-material/BookRounded';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import NotificationsRoundedIcon from '@mui/icons-material/NotificationsRounded';
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import BugReportRoundedIcon from '@mui/icons-material/BugReportRounded';
import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';


import Navigation from './Navigation';
import ColorSchemeToggle from '@components/ColorSchemeToggle';
import { Link, useLocation } from 'react-router-dom';
import { Badge, ListItem, SvgIcon } from '@mui/joy';
import { useAuth } from '@providers/AuthProvider';
import { useGetAllUserMeta } from '@api/userMetaService';
import MaestroLoader from '@components/MaestroLoader';
import Notifications from '@components/Notifications';
import Search from '@components/Search';
import CommunityJumper from '@components/CommunityJumper';
import ReportButtons from '@components/ReportButtons';
import { maestroIcon } from '@utils/assets';
import { isImpersonating } from 'api';

export default function Header() {
  const [open, setOpen] = React.useState(false);
  const {user, signOut, can} = useAuth();
  const { hash, pathname, search } = useLocation();


  const [dashboards, setDashboards] = React.useState([]);
  const { isLoading: isUserMetaLoading, data: userMeta } = useGetAllUserMeta();

  React.useEffect(() => {
    if(!userMeta) {
      return;
  }

  let dashboardsMeta = [];

  userMeta.data.map(obj => {
    if(obj.meta_key.indexOf('dashboard_settings') === -1) {
      return;
    }

    let metaValue = {};
    try {
      metaValue = JSON.parse(obj.meta_value);
    } catch(e) {
      //
    }

    if(metaValue.isPrimaryDashboard) {
      return;
    }

    dashboardsMeta.push({
      id: obj.meta_key.replaceAll(/[^0-9]/g, ''),
      name: metaValue.name,
    });

  });

  /*
  const dashboardsMeta = userMeta.map(obj => {console.log(obj.meta_value); return ({
    ...obj,
    meta_value: JSON.parse(obj.meta_value),
  })}).filter(obj =>
    obj.meta_key.indexOf('dashboard_settings') !== -1
    && !obj.meta_value.isPrimaryDashboard
  ).map(obj => ({
    id: obj.meta_key.replace(/[^0-9]/, ''),
    name: obj.meta_value.name,
  }));
  */

  setDashboards(dashboardsMeta);

  }, [userMeta])


const currentDashboard = pathname.indexOf('/dashboard/') > -1 ? parseInt(pathname.replace('/dashboard/', '')) : 0;

  return (
    <Box
      sx={{
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'space-between',
      }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        sx={{ display: { xs: 'none', md: 'flex' } }}
      >
        <Link to={`/dashboard`}>
        <Tooltip title="Go to Dashboard" variant="outlined">
            <IconButton
            size="md"
            variant="outlined"
            color="neutral"
          sx={{
                display: 'inline-flex',// { xs: 'none', md: 'inline-flex' },
                borderRadius: '50%',
            }}
            >
                <img
                    src={maestroIcon}
                    style={{
                      // width: 'calc(var(--IconButton-size) - 0.5rem)'
                      maxWidth: '100%',
                    }}
                />
            </IconButton>
        </Tooltip>
        </Link>


        <Box sx={{display:{ xs: 'none', md: 'inline-flex' }}}>
          {isUserMetaLoading && <MaestroLoader/>}
        {/* todo: make these scrollable/a dropdown for when someone has a bunch of dashboards */}
        {dashboards.map(dashboard => (
            <Link key={dashboard.id} to={`/dashboard/${dashboard.id}`}>
            <Button
                variant="plain"
                color="neutral"
                aria-pressed={parseInt(currentDashboard) === parseInt(dashboard.id) ? 'true' : 'false'}
                // component="a"
                // href="/joy-ui/getting-started/templates/email/"
                size="sm"
                sx={{ alignSelf: 'center' }}
            >
                {dashboard.name}
            </Button>
            </Link>
        ))}
        </Box>

      </Stack>
      <Box sx={{ display: { xs: 'inline-flex', md: 'none' } }} gap={1.5}>

        <Button
          onClick={() => setOpen(true)}
          variant="outlined"
          color="neutral"
          size="sm"
          startDecorator={<MenuRoundedIcon />}
        >
          Menu
        </Button>
        <Drawer
          sx={{ display: { xs: 'inline-flex', md: 'none' } }}
          open={open}
          onClose={() => setOpen(false)}
        >
          <ModalClose />
          <DialogTitle>Maestro</DialogTitle>
          <Box sx={{ px: 1 }}>
            <Navigation onClose={() => setOpen(false)} />
          </Box>
        </Drawer>


        <Dropdown>
          <MenuButton
            startDecorator={<DashboardRoundedIcon />}
            sx={theme => ({
              // make it act like an IconButton
              [theme.breakpoints.down('sm')]: {
                padding: '0',
                minWidth: 'var(--IconButton-size, 2rem)',
                minHeight: 'var(--IconButton-size, 2rem)',
                '.MuiMenuButton-startDecorator': {
                  '--Icon-margin': '0',
                  '--ButtonGap': '0',
                },
                // '--Icon-margin': '0',
                // '--ButtonGap': '0',
                '& span': {
                  margin: '0 auto',
                },
                '& .menu-text': {
                  display: 'none'
                }
              }
            })}
          >
            <span className='menu-text'>Dashboards</span>
          </MenuButton>
          <Menu
            placement="bottom-end"
            size="sm"
            sx={{
              zIndex: '99999',
              p: 1,
              gap: 1,
              '--ListItem-radius': 'var(--joy-radius-sm)',
              '--ListItem-minHeight': '1rem',
              '--ListDivider-gap': '0',
              '--Icon-fontSize': '1rem',
            }}
          >
          {dashboards.map(dashboard => (
            // <Link key={dashboard.id} >
            <MenuItem
              key={dashboard.id}
              variant="plain"
              color="neutral"
              selected={currentDashboard === dashboard.id ? true : false}
              component={Link}
              to={`/dashboard/${dashboard.id}`}
              // size="sm"
              // sx={{ alignSelf: 'center' }}
            >
              {dashboard.name}
            </MenuItem>
        ))}
          </Menu>
        </Dropdown>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: 1.5,
          alignItems: 'center',
        }}
      >

        <ReportButtons/>

        <Search/>

        {/* <CommunityJumper/> */}

        {/*
        <Tooltip title="Messages" variant="outlined">
            <Badge invisible={false}>
                <IconButton
                    size="sm"
                    variant="outlined"
                    color="neutral"
                    component="a"
                    href="/blog/first-look-at-joy/"
                    sx={{ alignSelf: 'center' }}
                >
                    <ForumRoundedIcon />
                </IconButton>
            </Badge>
        </Tooltip>
        */}

        <Notifications/>

        {/* <ColorSchemeToggle /> */}

        <Dropdown>
        <Tooltip title="Account" variant="outlined">
          <MenuButton
            size="sm"
            variant="outlined"
            sx={{ paddingInline: '.37rem' }}
          >
            <SvgIcon
                // size="md"
                // variant="outlined"
                // color="neutral"
                sx={{
                    display: 'inline-flex',
                    // borderRadius: '50%',
                }}
            >
                <AccountCircleRoundedIcon/>
            </SvgIcon>
          </MenuButton>
          </Tooltip>
          <Menu
            placement="bottom-end"
            size="sm"
            sx={{
              zIndex: '1101',
              p: 1,
              gap: 1,
              '--ListItem-radius': 'var(--joy-radius-sm)',
              '--ListItem-minHeight': '1rem',
              '--ListDivider-gap': '0',
              '--Icon-fontSize': '1rem',
            }}
          >
            <ListItem>
              <CommunityJumper/>
            </ListItem>

            <MenuItem component={Link} to='/profile'>
                {/* <SettingsRoundedIcon /> */}
                <Box>
                  <Typography level="title-sm" textColor="text.primary" sx={{maxWidth: '160px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                    {user?.first_name}{' '}{user?.last_name}
                  </Typography>
                  <Typography level="body-xs" textColor="text.tertiary" sx={{maxWidth: '160px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap'}}>
                    {user?.email}
                  </Typography>
                </Box>
            </MenuItem>

            <ListDivider />

            <MenuItem component={'a'} href="https://www.maestrocm.com/support/" target="_blank">
              <HelpRoundedIcon />
              Get Help
            </MenuItem>
            {/*
            <MenuItem component={'a'} href="https://www.maestrocm.com/report-a-bug/" target="_blank">
              <BugReportRoundedIcon />
              Report a Bug
            </MenuItem>
            */}

            <ListDivider />

            <MenuItem component={Link} to="/profile">
              <SettingsRoundedIcon />
              Account
            </MenuItem>

            {/* todo: add checks for whether the user can manage billing */}
            {can('manage billing') && (
              <MenuItem component={'a'} href="https://conductor.maestrocm.com" target="_blank">
                <AttachMoneyRoundedIcon />
                Billing
              </MenuItem>
            )}

            <ListDivider />
            <MenuItem onClick={signOut}>
              <LogoutRoundedIcon />
              {isImpersonating ? 'Stop Impersonating' : 'Log out'}
            </MenuItem>
          </Menu>
        </Dropdown>
      </Box>
    </Box>
  );
}
